<div class="customFilterContainer d-flex" *ngIf="allFilters">
    <div class="position-relative">
        <div class="btn btn-outline-primary" (click)="showFilters = !showFilters"><span><i class="fa-light fa-plus"></i></span> {{ 'Buttons.ChooseFilter' | translate  }}</div>
        <ul class="list-group position-absolute" style="top:100%;left:0;z-index:100;width:19rem;" *ngIf="showFilters">
            <li class="list-group-item d-flex justify-content-center" *ngIf="!allFilters.length">{{ 'Filters.NoFiltersFound' | translate }}</li>
            <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let x of allFilters; let i = index; trackBy:filterName" >
                <div class="d-flex align-items-center" (click)="activateFilter(x); showFilters = false;">
                    <div style="width:2rem;"><span *ngIf="active == x.name"><i class="fa-solid fa-circle-check text-primary"></i></span></div>
                    <div class="ml-1 cursor-pointer mr-3 flex-grow-1 ellipsis" title="{{ x.name }}">{{ x.name }}</div>
                </div>
                <div class="cursor-pointer ml-3" (click)="deleteFilter(i)"><i class="fa-light fa-trash-can"></i></div>
            </li>
        </ul>
    </div>
    <div class="btn btn-outline-primary ml-3" data-toggle="modal" data-target="#customFilterCreationModal" *ngIf="inputFilterNotSaved == true && noFilter == false"><span><i class="fa-regular fa-filter"></i></span> {{ 'Buttons.SaveFilter' | translate }}</div>
    <div class="btn btn-secondary ml-3" *ngIf="!!active">{{ active }} <span (click)="grid.api.setFilterModel(null);active = null;"><i class="fa-light fa-xmark"></i></span></div>
    <div class="btn btn-outline-light ml-3" (click)="grid.api.setFilterModel(null);active = null;" *ngIf="inputFilterNotSaved == true && noFilter == false"><span><i class="fa-light fa-xmark"></i></span> {{ 'Buttons.ClearFilter' | translate }}</div>
</div>

<div id="customFilterCreationModal" class="modal fade">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5>{{ 'Buttons.SaveFilter' | translate }}</h5>
            </div>
            <div class="modal-body">
                <input id="customFilterCreationInput" type="text" class="form-control" placeholder="{{ 'Standard.Name' | translate }}">
            </div>
            <div class="modal-footer flex-between">
                <button class="btn btn-sm btn-secondary" data-dismiss="modal">{{ 'Buttons.Close' | translate }}</button>
                <button class="btn btn-sm btn-success" (click)="addFilter()" data-dismiss="modal">{{ 'Buttons.Save' | translate }}</button>
            </div>

        </div>
    </div>
</div>
